"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApplicationEmployerStatement;
(function (ApplicationEmployerStatement) {
    ApplicationEmployerStatement["SAVED"] = "saved";
    ApplicationEmployerStatement["REJECTED"] = "rejected";
    ApplicationEmployerStatement["WAITING_FOR_RESPONSE"] = "waiting_for_response";
    ApplicationEmployerStatement["INVITED_FOR_NEXT_ROUND"] = "invited_for_next_round";
    ApplicationEmployerStatement["EMPLOYED"] = "employed";
})(ApplicationEmployerStatement = exports.ApplicationEmployerStatement || (exports.ApplicationEmployerStatement = {}));
//# sourceMappingURL=applications.js.map